import axios from "axios"

export const getToken = async () => {
  const url = process.env.REACT_APP_BITACORA_AUTH_URL;
  const authorization = process.env.REACT_APP_BITACORA_AUTH_AUTHORIZATION;
  const clientId = process.env.REACT_APP_BITACORA_AUTH_CLIENT_ID;
  const scope = process.env.REACT_APP_BITACORA_AUTH_SCOPE;

  if (!url || !authorization || !clientId || !scope) {
    console.log("Missing environment variables for token retrieval");
    return '';
  }

  const response = await axios.post(url, null, {
    headers: {
      authorization,
      client_id: clientId,
      scope,
    }
  });

  return response.status === 200 ? response.data.token : '';

};